import { useDemoMode } from '../../hooks/useDemoMode'

const DemoBanner = () => {
  const { isDemoMode, exitDemoMode } = useDemoMode()

  if (!isDemoMode) return null

  return (
    <div className="sticky top-0 z-[60] bg-gradient-to-r from-blue-600 via-blue-500 to-cyan-500 text-white shadow-lg">
      <div className="max-w-[1600px] mx-auto px-4 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-white/20 rounded-full px-3 py-1">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse" />
            <span className="text-xs font-semibold uppercase tracking-wider">Demo Mode</span>
          </div>
          <p className="text-sm font-medium hidden sm:block">
            You&apos;re exploring with sample data — nothing will be saved
          </p>
          <p className="text-sm font-medium sm:hidden">
            Exploring with sample data
          </p>
        </div>

        <button
          onClick={exitDemoMode}
          className="flex items-center gap-2 bg-white text-blue-600 px-4 py-1.5 rounded-lg text-sm font-semibold hover:bg-blue-50 transition-colors shadow-sm whitespace-nowrap"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
          <span className="hidden sm:inline">Ready to try it for real</span>
          <span className="sm:hidden">Start for real</span>
        </button>
      </div>
    </div>
  )
}

export default DemoBanner
